
<!--查看售后详情流程-->
<!-- subid 必传  -->
<template>
  <div class="div-b">
    <!-- <van-collapse v-model="activeNames"> -->
      <!-- <van-collapse-item title="处理进度" name="1"> -->
        <van-cell title="处理进度"  />
        <van-steps direction="vertical" active-color="#666666" :active-icon="spot">
          <template v-if="showFooterDowntime">
            <van-step v-for="(item, idx) in steps" :key="idx"  v-if="!isDevelop ? index == 0:index < steps.length">
              <h3 v-if="idx ===0" class="c1">
                店铺已同意，您需要
                <van-count-down style="color: #f8a651;font-size: 12px;display: inline;" :time="time" format="DD天HH:mm:ss" />
                内处理<span style="color: #f8a651;">{{stepsRow.afterSaleTypeDisplayName}}</span>
              </h3>
              <h3 v-else class="c2">{{item.nodeDesc}}</h3>
              <p style="color:#ccc">{{item.gmtCreated}}</p>
            </van-step>
          </template>
          <template v-else>
            <van-step v-for="(item, index) in steps" :key="index"  v-if="!isDevelop ? index == 0:index < steps.length">
              <h3 :class="index ===0 ? 'c1': 'c2'" class="c2">{{item.nodeDesc}}</h3>
              <p style="color:#ccc">{{item.gmtCreated}}</p>
            </van-step>
          </template>
        </van-steps> 
        <div class="develop" @click="onBindDevelop" v-if="steps.length > 2">
          <div class="develop_border">
            <span>{{!isDevelop ? '查看完整进度':'收起完整进度'}}</span>
            <img :class="isDevelop ? 'develop_image':''" :src="develop"/>
          </div>
        </div>

      <!-- </van-collapse-item> -->
    <!-- </van-collapse> -->
  </div>
</template>
<script>
import { Toast } from "vant";
import http from "@/utils/axios";
export default {
  props: {
    steps: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    },
    stepsRow: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
  },

  data() {
    return {
      activeNames: ["1"],
      list: [] ,
      spot:require('@/assets/image/spot.png'),
      time:0,
      develop:'https://img.chinabeego.com/uploadfile/2023/3/8/48.778356569440405.png',
      isDevelop:false  //是否展开完整进度

    };
  },
  methods: {
    onBindDevelop(){
      this.isDevelop = !this.isDevelop
    },

    init() {
      http({
        url: "order/app/order/after/orderAfterContent/" + this.subid,
        method: "get"
      }).then(rps => {
        this.list = rps.data;
      });
    }
  },
  created() {
    //this.init()
    let nowTime = new Date().getTime();
    let targetTime = this.stepsRow.branchPassTimeMills || 0;
    if (targetTime) {
      let spanTime1 = nowTime - targetTime;
      let spanTime = 1000 * 60 * 60 * 24 * 7 - spanTime1;
      this.time = spanTime;
    }
  },
  components: {},
  computed:{
    showFooterDowntime(){
      if((this.stepsRow.afterSaleType == 'JUST_PRODUCT'
      && this.stepsRow.status ==  'USER_SEND_GOODS_ING'
      && this.stepsRow.branchPassTimeMills != null)

      || (this.stepsRow.afterSaleType == 'CHANGE_PRODUCT'
      && this.stepsRow.status ==  'USER_SEND_GOODS_ING'
      && this.stepsRow.branchPassTimeMills != null)){
        return true
      }else{
        return false
      }
    }
  }
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.develop{
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
}
.develop_border{
  width: 232px;
  height: 50px;
  line-height: 50px;
  background: #FFFFFF;
  border-radius: 32px;
  border: 1px solid #999999;
  text-align: center;
  font-size: 24px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
}
.develop_border img{
  width: 30px;
  height: 30px;
}
.develop_image{
  transform:rotate(180deg)
}

.div-b {
  font-size: 24px;
  border-radius: 0.15rem;
  background-color: #fff;
  text-align: left;
  .c1{
    font-size: 24px;
    color: #666666;
    font-weight: 400;
  }
  .c2{
    font-size: 24px;
    color: #666666;
    font-weight: 400;
  }
}
/deep/.van-step__title {
  font-size: 24px;
}
/deep/.van-step__circle{
  width: 22px;height: 22px;
  background: #ccc;
}
/deep/.van-step__line{
  background-color: #ccc;
}
.mt-5 {
  margin-bottom: 0.2rem;
}
</style>